export function isDevWidgetEnabled(configEnv: string): boolean {
  // this will be available both on browser and server
  return ['development', 'dev1', 'uat'].includes(configEnv);
}
